import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppUserClaimsService } from '../services/app-user-claims.service';
import { UserRoles, productCodes } from '../constants/constants';
import { FeatureToggleService } from '../services/feature-toggle.service';
import { AccountsService } from '../services/accounts.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class TemplateManagementGuard  {
    constructor(
        private route: Router,
        private appUserClaimsSvc: AppUserClaimsService,
        private featureToggleService: FeatureToggleService,
        private accService: AccountsService
    ) {}

    canActivate():  Observable<boolean> | boolean {

        const claims = this.appUserClaimsSvc.getClaims();
        const assumed = this.appUserClaimsSvc.isAssumedRole();
        // If Partner_Admin, policy should be on prime
        // If Account_Admin, policy should be on customer account

        if( claims.role === UserRoles.ACCOUNT_ADMIN || assumed) {
            // need to also check for Gateway and MiVoice Business in tags
            return this.checkIfTagsSetInAccountSvc().pipe(map ( value => 
                {
                    if (this.checkForRequiredIntegrations()){
                        console.log("MiVB guard: Customer account has required integrations");
                        return true;
                    }
                    else{
                        console.log("MiVB guard: Customer account missing required integrations");
                        this.route.navigate(['navigationError']);
                        return false;
                    } 
                })
            );
        }
        else if( claims.role === UserRoles.PARTNER_ADMIN){
            console.log("MiVB guard: Partner has required policy");
            return true;
        }
 
        this.route.navigate(['navigationError']);
        return false;

    }

    checkIfTagsSetInAccountSvc() {
        if (this.accService.getCurrentAccountTags()) {
            console.log("MiVB Guard tags:", this.accService.getCurrentAccountTags());
            return of(true);
        } else {
            return this.accService.accountTagChanged.asObservable();
        }
    }

    //Account must have both Gateway and MiVoice Business in product tags
    checkForRequiredIntegrations() {
        let tags = this.accService.getCurrentAccountTags();
        let requiredProductsExist = false;
        if(tags && tags.products){
            let requiredProducts = [productCodes.GATEWAY, productCodes.MIVOICE_BUSINESS];
            requiredProductsExist = requiredProducts.every(product => {
                return tags.products.includes(product);
            });
        }
        return requiredProductsExist;
    }

}